import { render, staticRenderFns } from "./InitPurchase.vue?vue&type=template&id=4c50a8f2"
import script from "./InitPurchase.vue?vue&type=script&lang=js"
export * from "./InitPurchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports